import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { HubspotTicketComponent } from './hubspot-ticket/hubspot-ticket.component';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { TooltipModule } from "ngx-tooltip";
import { DashboardService } from '../dashboard/dashboard.service';
import { AdministratorService } from '../administrator/administrator.service';
import { PlanEditorComponent } from './plan-editor/plan-editor.component';
import { PlanService } from '../services/plan.service';
import { CurrencyMaskModule } from "ng2-currency-mask";
import { NgxMaskModule, IConfig } from 'ngx-mask'
import { DonationDetailComponent } from './donation-detail/donation-detail.component';
import { CauseSelectorComponent } from './cause-selector/cause-selector.component';
import { HireFeatureComponent } from './hire-feature/hire-feature.component';
import { SecureVideoComponent } from './secure-video/secure-video.component';
import { DepositEditorComponent } from './deposit-editor/deposit-editor.component';
import { GlobalPaymentComponent } from './payment/global-payment/global-payment.component';
import { BillingFormComponent } from './payment/billing-form/billing-form.component';
import { TextMaskModule } from 'angular2-text-mask';
import { CampaignService } from '../campaign/campaign.service';
import { CreditCardEditorComponent } from './payment/creditcard-editor/creditcard-editor.component';
import { HelperService } from '../services/helper.service';
import { PaymentMethodSelectorComponent } from './payment/paymentmethod-selector/paymentmethod-selector.component';
import { ConfirmPlanComponent } from './payment/confirm-plan/confirm-plan.component';
import { PlanItensViewerComponent } from './planItens-viewer/planItens-viewer.component';
import { ProfileService } from '../profile/profile.service';
import { AuthenticationService } from '../authentication/authentication.service';
import { CabiancaChartComponent } from './analytics/cabianca-chart/cabianca-chart.component';
import { SlotarrowComponent } from './analytics/slotarrow/slotarrow.component';
import { SlotbarComponent } from './analytics/slotbar/slotbar.component';
import { PageAnalyticsComponent } from './page-analytics/page-analytics.component';
import { SelectNgoComponent }  from './select-ngo/select-ngo.component';
import { SelectNgoService } from './select-ngo/select-ngo.service';
import { NewBillingFormComponent } from './payment/new-billing-form/new-billing-form.component';

@NgModule({
    imports: [
        FormsModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TextMaskModule,
        TooltipModule,
        NgxSmartModalModule.forRoot(),
        NgxMaskModule.forRoot(),
        CurrencyMaskModule
    ],
    declarations: [
        HubspotTicketComponent,
        HireFeatureComponent,
        PlanEditorComponent,
        DonationDetailComponent,
        DepositEditorComponent,
        CauseSelectorComponent,
        SecureVideoComponent,
        BillingFormComponent,
        PaymentMethodSelectorComponent,
        CreditCardEditorComponent,
        ConfirmPlanComponent,
        GlobalPaymentComponent,
        PlanItensViewerComponent,
        CabiancaChartComponent,
        SlotarrowComponent,
        SlotbarComponent,
        PageAnalyticsComponent,
        SelectNgoComponent,
        NewBillingFormComponent
    ],
    providers: [
        AuthenticationService,
        DashboardService,
        ProfileService,
        AdministratorService,
        CampaignService,
        PlanService,
        HelperService,
        SelectNgoService
    ],
    exports: [
        HireFeatureComponent,
        HubspotTicketComponent,
        DonationDetailComponent,
        DepositEditorComponent,
        PlanEditorComponent,
        CauseSelectorComponent,
        SecureVideoComponent,
        BillingFormComponent,
        PaymentMethodSelectorComponent,
        CreditCardEditorComponent,
        ConfirmPlanComponent,
        GlobalPaymentComponent,
        PlanItensViewerComponent,
        CabiancaChartComponent,
        SlotarrowComponent,
        SlotbarComponent,
        PageAnalyticsComponent,
        SelectNgoComponent
    ]
})

export class SharedModule { }
